import { useEffect } from 'react';

export function useGoogleTag(gaId: string) {
  useEffect(() => {
    if (!gaId || typeof window === 'undefined') return;

    // Check if the script is already injected to avoid duplicates
    if (document.querySelector(`script[src*="${gaId}"]`)) {
      return;
    }

    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
    document.head.appendChild(script2);
  }, [gaId]);
}
